<input 
    [type]="type"
    [(ngModel)]="input"
    [placeholder]="placeholder" 
    (input)="onInput.emit(input)"
    (keyup.enter)="onEnter.emit()"
    class="font-body2" />